import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';
import {
  IOverseasPersonneParams, 
  IOverseasPersonnelItem,
  IOverseasPersonnelDetail,
  ICountryRegionItem,
  ISettlementOrderImportItem,
  ISettlementOrderImportSelect, 
} from '@core/main/types';

const hostUrl = getHostbaseUrl();

/**
 * 账户中心 - 海外人员列表（分页）
 * @param params IOverseasPersonneParams
 */
export async function queryOverseasPersonnelPage(params: IOverseasPersonneParams) {
  let data = [] as IOverseasPersonnelItem[];
  let total = 0;

  params = JSON.parse(JSON.stringify(params)) as IOverseasPersonneParams;

  try {
    const { code, context, message } = await Http.post<{ data: IOverseasPersonnelItem[]; total: number }>(`${hostUrl}/iam/oversea-customer/page`, params);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: IOverseasPersonnelItem[]; total: number };

      data = items || [];
      total = all || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 * 账户中心 - 海外人员列表
 * @param companyId 企业Id
 */
export async function queryOverseasPersonnelList(companyId: number) {
  let data = [] as IOverseasPersonnelItem[];

  try {
    const { code, context, message } = await Http.get<IOverseasPersonnelItem[]>(`${hostUrl}/iam/oversea-customer/list`, { companyId });

    if (code === EAxiosResponseCode.Succeed) {
      const items = context || [] as IOverseasPersonnelItem[];

      data = items;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 账户中心 - 海外人员详情
 * @param id 海外人员id
 */
export async function queryOverseasPersonnelDetail(id: number) {
  let res = {} as IOverseasPersonnelDetail;

  try {
    const { code, context, message } = await Http.get<IOverseasPersonnelDetail>(`${hostUrl}/iam/oversea-customer/detail`, { id });

    if (code === EAxiosResponseCode.Succeed) {
      res = context || res;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return res;
}

/**
 * 账户中心 - 保存海外人员
 * @param params IOverseasPersonnelDetail
 */
export async function saveOverseasPersonnel(params: IOverseasPersonnelDetail) {
  try {
    const { code, message } = await Http.post(`${hostUrl}/iam/oversea-customer/edit`, params);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 账户中心 - 国家-地区列表
 */
export async function queryCountryRegionList() {
  let res = [] as ICountryRegionItem[];

  try {
    const { code, context, message } = await Http.get<ICountryRegionItem[]>(`${hostUrl}/iam/country-region/list`);

    if (code === EAxiosResponseCode.Succeed) {
      res = context || res;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return res;
}

/**
 * 账户中心 - 校验海外人员excel
 */
export async function checkOverseasDetail(params: ISettlementOrderImportSelect) {
  let data = {} as { orderDetailList: ISettlementOrderImportItem[] };

  try {
    const { code, context, message } = await Http.post<{orderDetailList: ISettlementOrderImportItem[]}>(`${hostUrl}/pay/crowd/order/build-order-by-oversea-customer`, params);

    if (code === EAxiosResponseCode.Succeed) {
      data = context || {} as { orderDetailList: ISettlementOrderImportItem[] };
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

